import { render, staticRenderFns } from "./PurimNewTrack.vue?vue&type=template&id=27416a08&"
import script from "./PurimNewTrack.vue?vue&type=script&lang=js&"
export * from "./PurimNewTrack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports